module.exports = __webpack_public_path__ + "media/images/icons/active-doctors-percent-c66dc9a24d3b3124d4b1b1a11219edae.svg";